export const readableFileSize = (fileSize?: number) => {
  if (!fileSize) {
    return '0 KB';
  }

  const sizeInKb = fileSize / 1024;
  const sizeInMb = sizeInKb / 1024;

  if (sizeInMb > 1024) {
    return `${(sizeInMb / 1024).toFixed(2)} GB`;
  }

  if (sizeInKb > 1024) {
    return `${sizeInMb.toFixed(2)} MB`;
  }

  return `${sizeInKb.toFixed(2)} KB`;
};
